"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.alphaNumComparator = exports.default = exports.StatefulTable = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _icon = _interopRequireDefault(require("../icon"));

var _classnames2 = _interopRequireDefault(require("classnames"));

var _indexModule = _interopRequireDefault(require("./index.module.scss"));

var _excluded = ["columns", "className", "rows", "sortBy", "onSort", "rowDecorator"];

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

/**
 * Table component with optional sorting and custom column heading and value
 * renderers.
 *
 * Comes in stateful and stateless flavours. The stateful flavour takes manages
 * a single prop as state - the `sortBy` prop. Everything else is delegated to
 * the stateless component.
 *
 * Basic accessibility support. No support for headings or keyboard navigation
 * yet.
 *
 * This document was referenced as the source for aria roles:
 * https://www.w3.org/TR/wai-aria-practices/examples/grid/dataGrids.html
 *
 * Table also will pass on any developer-supplied props to the rendered
 * <table> element (see the `restProps` parameter below).
 */
var Table = function Table(_ref) {
  var columns = _ref.columns,
      className = _ref.className,
      rows = _ref.rows,
      sortBy = _ref.sortBy,
      onSort = _ref.onSort,
      rowDecorator = _ref.rowDecorator,
      restProps = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  // Take a shallow copy of the rows array so that we don't mutate the array
  // when we sort it.
  var copiedRows = rows.slice(0, rows.length);
  var columnsNormalised = columns.map(function (column) {
    return _objectSpread(_objectSpread({}, column), {}, {
      headingRenderer: wrapColumnHeadingRenderer(column.headingRenderer || DefaultColumnHeadingRenderer),
      valueRenderer: wrapValueRenderer(column.valueRenderer || DefaultValueRenderer)
    });
  });
  var rowDecoratorFn = rowDecorator || DefaultRowDecorator;
  return /*#__PURE__*/_react.default.createElement("table", (0, _extends2.default)({
    role: "grid",
    "aria-rowcount": rows.length,
    "aria-colcount": columns.length,
    className: (0, _classnames2.default)(_indexModule.default.Table, className)
  }, restProps), /*#__PURE__*/_react.default.createElement("thead", {
    className: _indexModule.default.TableHead
  }, /*#__PURE__*/_react.default.createElement("tr", {
    role: "row",
    className: _indexModule.default.TableRow
  }, columnsNormalised.map(function (column) {
    return column.headingRenderer(column, sortBy, onSort);
  }))), /*#__PURE__*/_react.default.createElement("tbody", null, sortedRows(copiedRows, columns, sortBy).map(function (row, index) {
    return rowDecoratorFn(row, /*#__PURE__*/_react.default.createElement("tr", {
      role: "row",
      className: _indexModule.default.TableRow,
      key: index
    }, columnsNormalised.map(function (column) {
      return column.valueRenderer(column, row, row[column.key]);
    })), index);
  })));
};
/**
 * This is a stateful version of Table that handles re-sorts of the rows.
 * Use this when you're not using a state manager in your React app.
 *
 * It accepts the same props as Table but overrides `onSort` in order to
 * handle it internally.
 */


var StatefulTable = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2.default)(StatefulTable, _React$Component);

  var _super = _createSuper(StatefulTable);

  function StatefulTable(props) {
    var _this;

    (0, _classCallCheck2.default)(this, StatefulTable);
    _this = _super.call(this, props);
    _this.state = {
      sortBy: Object.assign({}, props.sortBy)
    };
    return _this;
  }

  (0, _createClass2.default)(StatefulTable, [{
    key: "render",
    value: function render() {
      var props = _objectSpread(_objectSpread({}, this.props), {}, {
        sortBy: this.state.sortBy,
        onSort: this.onSort.bind(this)
      });

      return /*#__PURE__*/_react.default.createElement(Table, props);
    }
  }, {
    key: "onSort",
    value: function onSort(_ref2) {
      var columnKey = _ref2.columnKey,
          direction = _ref2.direction;

      if (columnKey === this.state.sortBy.columnKey) {
        this.setState({
          sortBy: {
            columnKey: columnKey,
            direction: reverseDirection(direction)
          }
        });
      } else {
        this.setState({
          sortBy: {
            columnKey: columnKey,
            direction: direction
          }
        });
      }
    }
  }]);
  return StatefulTable;
}(_react.default.Component);

exports.StatefulTable = StatefulTable;
Table.propTypes = StatefulTable.propTypes = {
  /**
   * An array of column metadata for the table. The array should be provided
   * in the order that the columns should be rendered.
   */
  columns: (0, _propTypes.arrayOf)((0, _propTypes.shape)({
    /**
     * This key is used to look up the vale for the column in each row object.
     */
    key: _propTypes.string.isRequired,

    /**
     * The heading of the column
     */
    heading: _propTypes.string.isRequired,

    /**
     * Optional developer-overridable heading render function for the column
     * header. The renderer must have the following signature:
     *
     * (column, sortBy, onSort) => ReactElement
     *
     * See the `DefaultColumnHeadingRenderer` documentation for more info.
     */
    headingRenderer: _propTypes.func,

    /**
     * Optional User overridable heading render function for the column.
     * The renderer must have the following signature:
     *
     * (column, row, value) => ReactElement
     *
     * See the `DefaultValueRenderer` documentation for more info.
     */
    valueRenderer: _propTypes.func,

    /**
     * An optional comparator function for values in the column.
     *
     * A comparator function has the form: (a, b) => number, where number is
     * -1, 0 or 1.
     *
     * Refer to JavaScript's Array.sort() documentation.
     *
     * NOTE: the comparator should be written to sort results in ascending
     * (ASC) order. The table component assumes this in order to automatically
     * invert the sort order when the user toggles the sort.
     */
    comparatorFn: _propTypes.func,

    /**
     * This className will be attached to the rendered element so that the
     * developer can override styling for the column.
     */
    className: _propTypes.string
  })).isRequired,

  /**
   * An array data rows. Each element in the array should be an object with
   * property names that match the `columnKey`s as defined in the columns
   * metadata.
   */
  rows: (0, _propTypes.arrayOf)(_propTypes.object).isRequired,

  /**
   * Defines the current sort column and sort direction. Can be undefined if no
   * sort is to be performed.
   */
  sortBy: (0, _propTypes.shape)({
    /**
     * The key of the column to sort by.
     */
    columnKey: _propTypes.string,

    /**
     * The order to sort by.
     */
    direction: (0, _propTypes.oneOf)(['ASC', 'DESC'])
  }),

  /**
   * Callback function to resort the rows. This is triggered when the user clicks
   * on the header of a sortable column. The Table component is stateless, so
   * the developer must use this to hook the Table up to the React app's state
   * management to ultimately update the `sortBy` prop that is passed to the
   * Table.
   *
   * However, the stateful version of the table will hook this up for you so
   * you will not need to provide the callback in that case.
   */
  onSort: _propTypes.func,

  /**
   * Optional styling
   */
  className: (0, _propTypes.oneOfType)([_propTypes.object, _propTypes.string]),

  /**
   * An optional decorator function for rows.
   *
   * The renderer must have the following signature:
   *
   * (row, ReactElement) => ReactElement
   *
   * Where the ReactElement is a `<tr />` The row information is passed to the
   * function so attributes can be used to decorate the row (i.e. create an
   * onClick prop pointing to a URL using an id passed in the row object)
   */
  rowDecoratorFn: _propTypes.func
};
var _default = Table;
/**
 * Renders a column heading. User implementations must render a `<th>` tag as
 * the outermost element.
 *
 * @param `column` the column metadata
 * @param `sortBy` the `sortBy` prop from the table
 * @param `onSort` the callback function to invoke to sort the table
 *        with the following signature:
 *        `({columnKey: string, direction: string}) => void`
 *
 */

exports.default = _default;

var DefaultColumnHeadingRenderer = function DefaultColumnHeadingRenderer(column, sortBy, onSort) {
  return /*#__PURE__*/_react.default.createElement("th", null, column.heading, isSortable(column) && column.key === sortBy.columnKey && /*#__PURE__*/_react.default.createElement(SortDirection, {
    sortDirection: sortBy.direction
  }));
};

var DefaultRowDecorator = function DefaultRowDecorator(row, element, index) {
  return element;
};
/**
 * Adds mandatory props to the potentially developer-supplied `headingRenderer`.
 */


var wrapColumnHeadingRenderer = function wrapColumnHeadingRenderer(renderer) {
  return function (column, sortBy, onSort) {
    var rendered = renderer(column, sortBy, onSort);
    var props = {
      className: (0, _classnames2.default)(column.className, (0, _defineProperty2.default)({}, _indexModule.default.isSortable, isSortable(column))),
      key: column.key,
      role: 'gridcell'
    };

    if (isSortable(column) && onSort) {
      props.onClick = function () {
        return onSort({
          columnKey: column.key,
          direction: sortBy.direction
        });
      };

      if (column.key === sortBy.columnKey) {
        props['aria-sort'] = sortBy.direction === 'ASC' ? 'ascending' : 'descending';
      } else {
        props['aria-sort'] = 'none';
      }

      return injectAriaAttrsForTh(rendered, props);
    }

    return /*#__PURE__*/_react.default.cloneElement(rendered, props);
  };
};

var TABINDEX_FOCUSSABLE = '-1';
/**
 * Converts the rendered `<th>{ children }</th>` element into
 * `<th><span role="button" tabIndex="-1">{ children }</span></th>`.
 *
 * The reduces the burden on the developer to remember to correctly mark-up
 * their custom renderer output to support aria attributes.
 */

var injectAriaAttrsForTh = function injectAriaAttrsForTh(element, props) {
  return /*#__PURE__*/_react.default.cloneElement(element, _objectSpread({
    children: /*#__PURE__*/_react.default.createElement('span', {
      role: 'button',
      tabIndex: TABINDEX_FOCUSSABLE,
      children: element.props.children
    })
  }, props));
};
/**
 * The default renderer for values.
 *
 * Any developer-supplied renderer much render a `<td>` element.
 *
 * @param `column` the column metadata for the value
 * @param `row` the current row data
 * @param `value` the value to render
 */


var DefaultValueRenderer = function DefaultValueRenderer(column, row, value) {
  return /*#__PURE__*/_react.default.createElement("td", null, value && value.toString() || '');
};
/**
 * Adds manadatory props to the potentially developer-supplied `valueRenderer`.
 */


var wrapValueRenderer = function wrapValueRenderer(renderer) {
  return function (column, row, value) {
    return /*#__PURE__*/_react.default.cloneElement(renderer(column, row, value), {
      key: column.key,
      role: 'gridcell'
    });
  };
};
/**
 * Given a columnKey and a value comparator function, returns a new comparator
 * function that compares the values for the given column key.
 */


var sortByColumn = function sortByColumn(columnKey, comparatorFn) {
  return function (a, b) {
    return comparatorFn(a[columnKey], b[columnKey]);
  };
};
/**
 * Inverts the sort direction (ASC -> DESC, DESC -> ASC) of a comparator
 * function.
 */


var invertComparator = function invertComparator(comparatorFn) {
  return function (a, b) {
    return comparatorFn(b, a);
  };
};
/**
 * Given "ASC" returns "DESC" and given "DESC" returns "ASC"
 */


var reverseDirection = function reverseDirection(direction) {
  return direction === 'ASC' ? 'DESC' : 'ASC';
};
/**
 * Function component that renders an up or down arrow depending on the sort
 * direction.
 */


var SortDirection = function SortDirection(_ref3) {
  var sortDirection = _ref3.sortDirection;
  return sortDirection === 'ASC' ? /*#__PURE__*/_react.default.createElement(_icon.default, {
    className: _indexModule.default.Icon,
    size: 'small',
    type: 'chevron-down'
  }) : /*#__PURE__*/_react.default.createElement(_icon.default, {
    className: _indexModule.default.Icon,
    size: 'small',
    type: 'chevron-up'
  });
};

SortDirection.propTypes = {
  sortDirection: (0, _propTypes.oneOf)(['ASC', 'DESC']).isRequired
};
/**
 * Returns whether the column is sortable.
 */

var isSortable = function isSortable(column) {
  return Boolean(column.comparatorFn);
};
/**
 * If `sortBy` is defined this function will sort the rows according to
 * the `comparatorFn` defined on that column, else it will return the `rows`
 * array unmodified.
 */


var sortedRows = function sortedRows(rows, columns) {
  var sortBy = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
    columnKey: undefined,
    direction: undefined
  };
  var comparatorFn = (columns.find(function (column) {
    return column.key === sortBy.columnKey;
  }) || {
    comparatorFn: undefined
  }).comparatorFn;

  if (comparatorFn) {
    var comparatorFnWithDirection = sortBy.direction === 'ASC' ? comparatorFn : invertComparator(comparatorFn);
    return rows.sort(sortByColumn(sortBy.columnKey, comparatorFnWithDirection));
  } else {
    return rows;
  }
};
/**
 * Handy comparator function for alpha-numeric comparison.
 * Works with strings or numbers but not a mix of both.
 */


var alphaNumComparator = function alphaNumComparator(a, b) {
  return a < b ? -1 : a > b ? 1 : 0;
};

exports.alphaNumComparator = alphaNumComparator;